var format = function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (!template) return template;
  return String(template).replace(/\{([^{}]+)\}/g,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (_match, key) {
    return args[key] ? args[key] : key;
  });
};
var replaceAllDots = function replaceAllDots(str) {
  return str.replace(new RegExp(/\./g, 'g'), '-');
};

export { format, replaceAllDots };
//# sourceMappingURL=stringFormatter.js.map
